(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yumbella-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[id^="YumBellaNewsletter-"]';

    const initialiseNewsletter = (section) => {
      const form = section.querySelector('[data-yb-newsletter-form]');

      if (!form || form.dataset.ybEnhanced === 'true' || form.querySelector('.yb-newsletter-success')) return;
      form.dataset.ybEnhanced = 'true';

      const showSuccess = () => {
        const note = section.querySelector('[data-yb-newsletter-note]');
        const success = document.createElement('div');

        success.className = 'yb-newsletter-success';
        success.setAttribute('role', 'status');
        success.setAttribute('aria-live', 'polite');
        success.innerHTML = [
          '<span class="yb-newsletter-success__icon" aria-hidden="true">✓</span>',
          '<span class="yb-newsletter-success__copy">',
          '<strong>Thanks — you’re on the list.</strong>',
          '<small>Check your inbox for your welcome treat.</small>',
          '</span>'
        ].join('');

        const currentHeight = Math.ceil(form.getBoundingClientRect().height);
        form.style.minHeight = `${currentHeight}px`;
        form.classList.add('is-complete');
        form.removeAttribute('aria-busy');
        form.replaceChildren(success);
        note?.remove();

        requestAnimationFrame(() => success.classList.add('is-visible'));
        window.setTimeout(() => {
          form.style.minHeight = '';
        }, 600);
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!form.reportValidity()) return;

        const button = form.querySelector('button[type="submit"]');
        const originalLabel = button?.textContent || '';

        form.setAttribute('aria-busy', 'true');
        if (button) {
          button.disabled = true;
          button.textContent = 'Joining…';
        }

        try {
          const submitUrl = new URL(form.action, window.location.href);
          submitUrl.hash = '';

          const response = await fetch(submitUrl.toString(), {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            redirect: 'follow',
            headers: { Accept: 'text/html' }
          });

          if (!response.ok) throw new Error('Newsletter signup was not accepted');

          showSuccess();
        } catch (error) {
          form.removeAttribute('aria-busy');
          if (button) {
            button.disabled = false;
            button.textContent = originalLabel;
          }

          let errorMessage = form.querySelector('.yb-newsletter-error');
          if (!errorMessage) {
            errorMessage = document.createElement('div');
            errorMessage.className = 'yb-newsletter-error';
            errorMessage.setAttribute('role', 'alert');
            form.appendChild(errorMessage);
          }
          errorMessage.textContent = 'Sorry, that didn’t work. Please try again.';
        }
      });
    };

    const initialiseAll = (root = document) => {
      if (root instanceof Element && root.matches(sectionSelector)) {
        initialiseNewsletter(root);
      }
      root.querySelectorAll?.(sectionSelector).forEach(initialiseNewsletter);
    };

    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
